import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useCustomers } from "../../api/customers";
import { useDebounce } from "../../hooks/useDebounce";
import { StatusTag } from "../../components/StatusTag";
import { PaginationBar } from "../../components/PaginationBar";
import { formatBRL, formatDate } from "../../utils/money";
import { pillBtnStyle } from "../../utils/pillButton";
import { NewCustomerModal } from "./NewCustomerModal";
import { CustomerDetailDrawer } from "./CustomerDetailDrawer";

export default function CustomersPage() {
  const [searchParams] = useSearchParams();
  const [q, setQ] = useState(searchParams.get("q") ?? "");
  const [page, setPage] = useState(1);
  const [showNew, setShowNew] = useState(false);
  const [openCustomerId, setOpenCustomerId] = useState<number | null>(null);
  const debouncedQ = useDebounce(q);

  const { data, isLoading, isError } = useCustomers({ page, pageSize: 7, q: debouncedQ || undefined });

  return (
    <div className="d-flex flex-column gap-3">
      <div className="row g-2">
        <div className="col-md-6">
          <label className="nt-field-label">Buscar</label>
          <input
            className="form-control"
            placeholder="Buscar por nome, documento ou e-mail…"
            value={q}
            onChange={(e) => {
              setQ(e.target.value);
              setPage(1);
            }}
          />
        </div>
        <div className="col-md-3" />
        <div className="col-md-3">
          <label className="nt-field-label d-none d-md-block">&nbsp;</label>
          <button type="button" className="btn btn-primary w-100" onClick={() => setShowNew(true)}>
            Novo cliente
          </button>
        </div>
      </div>

      {isLoading && <div className="text-secondary">Carregando…</div>}
      {isError && <div className="text-danger">Não foi possível carregar os clientes.</div>}

      {data && (
        <div className="nt-table-wrap" style={{ overflowX: "auto" }}>
          <table className="table nt-table-fade table-striped align-middle">
            <thead>
              <tr>
                <th style={{ width: 280 }}>Cliente</th>
                <th style={{ width: 190 }}>CNPJ / CPF</th>
                <th style={{ width: 190 }}>Aplicação</th>
                <th style={{ width: 140 }}>Plano</th>
                <th style={{ width: 130 }}>Mensalidade</th>
                <th style={{ width: 110 }}>Situação</th>
                <th style={{ width: 110 }}>Desde</th>
                <th style={{ width: 100 }}></th>
              </tr>
            </thead>
            <tbody>
              {data.data.map((c) => (
                <tr key={c.id}>
                  <td style={{ fontFamily: "var(--font-heading)" }}>{c.razaoSocial}</td>
                  <td className="nt-tabular">{c.cnpjCpf}</td>
                  <td>{c.application ?? "—"}</td>
                  <td>{c.plan ?? "—"}</td>
                  <td className="text-end nt-tabular">{formatBRL(c.monthlyValue)}</td>
                  <td>
                    <StatusTag status={c.status} />
                  </td>
                  <td>{formatDate(c.sinceDate)}</td>
                  <td className="text-end">
                    <button type="button" style={pillBtnStyle("#000000")} onClick={() => setOpenCustomerId(c.id)}>
                      Abrir
                    </button>
                  </td>
                </tr>
              ))}
              {data.data.length === 0 && (
                <tr>
                  <td colSpan={8} className="text-secondary text-center py-4">
                    Nenhum cliente encontrado.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      {data && <PaginationBar page={data.page} pageSize={data.pageSize} total={data.total} onPageChange={setPage} />}

      <NewCustomerModal show={showNew} onClose={() => setShowNew(false)} />
      <CustomerDetailDrawer customerId={openCustomerId} onClose={() => setOpenCustomerId(null)} />
    </div>
  );
}
